import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Flashcard } from '../models/flashcard.model';

@Injectable({
  providedIn: 'root'
})
export class FlashcardService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  getAnswerFeedback(flashcardId: number, submittedAnswer: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/flashcards/practice-feedback`, { flashcardId: flashcardId, submittedAnswer: submittedAnswer });
  }

  getFlashcards(learnsetId: number): Observable<Flashcard[]> {
    return this.http.get<Flashcard[]>(`${this.baseUrl}/flashcards/${learnsetId}`);
  }

  saveFlashcards(flashcards: Flashcard[], createdType: 'file-upload' | 'from-text' | 'manually' | 'ai-assistant'): Observable<Flashcard[]> {
    return this.http.post<Flashcard[]>(`${this.baseUrl}/flashcards/save`, { flashcards: flashcards, createdType });
  }

  updateFlashcards(flashcards: Flashcard[]): Observable<Flashcard[]> {
    return this.http.post<Flashcard[]>(`${this.baseUrl}/flashcards`, { flashcards: flashcards });
  }

  updateFlashcardAfterPractice(flashcard: Flashcard, isSmartRepetition: boolean, grade?: number): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/flashcards/update/practice`, { flashcard: flashcard, grade: grade, isSmartRepetition: isSmartRepetition });
  }

  generateFlashcardAnswer(question: string) {
    return this.http.post<any>(`${this.baseUrl}/flashcards/generate-answer`, { question: question });
  }

  generateAiExplanation(flashcardId: number) {
    return this.http.get<any>(`${this.baseUrl}/flashcards/ai-explanation/${flashcardId}`);
  }

  deleteFlashcard(id: number) {
    return this.http.delete<any>(`${this.baseUrl}/flashcards/${id}`);
  }

  getTodaysLearnedFlashcards() {
    return this.http.get<any>(`${this.baseUrl}/user-activity/learned-flashcards`);
  }
}
